import React, { useState } from 'react';

function ContactForm() {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    message: ''
  });

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const sendWhatsAppMessage = (e) => {
    e.preventDefault();

    const { name, email, message } = formData;

    const whatsappMessage = `Hi Spark AI Team! 👋\n\n📌 *Name:* ${name}\n📧 *Email:* ${email}\n📝 *Message:* ${message}`;
    const encodedMessage = encodeURIComponent(whatsappMessage);
    const phoneNumber = '919949337308';

    window.open(`https://wa.me/${phoneNumber}?text=${encodedMessage}`, '_blank');
  };

  return (
    <div style={{
      maxWidth: '600px',
      margin: '60px auto',
      padding: '30px',
      background: 'rgba(255, 255, 255, 0.1)',
      borderRadius: '16px',
      boxShadow: '0 8px 32px rgba(0,0,0,0.3)',
      backdropFilter: 'blur(10px)',
      color: '#fff',
      fontFamily: 'Poppins, sans-serif',
      position: 'relative',
    }}>
      {/* Gradient Heading */}
      <h2 style={{
        background: 'linear-gradient(to right, #ffcb05, #f7be03)',
        WebkitBackgroundClip: 'text',
        WebkitTextFillColor: 'transparent',
        fontWeight: 700,
        fontSize: '1.8rem',
        textAlign: 'center',
        marginBottom: '25px'
      }}>
        💬 Contact Spark AI Team
      </h2>

      {/* Form */}
      <form onSubmit={sendWhatsAppMessage}>
        <input
          type="text"
          name="name"
          placeholder="Your Full Name"
          value={formData.name}
          onChange={handleChange}
          required
          style={inputStyle}
        />

        <input
          type="email"
          name="email"
          placeholder="Your Email Address"
          value={formData.email}
          onChange={handleChange}
          required
          style={inputStyle}
        />

        <textarea
          name="message"
          placeholder="Type your message here..."
          value={formData.message}
          onChange={handleChange}
          required
          style={{ ...inputStyle, height: '100px', resize: 'none' }}
        />

        <button type="submit" style={buttonStyle}>
          🚀 Send via WhatsApp
        </button>
      </form>
    </div>
  );
}

const inputStyle = {
  width: '100%',
  padding: '12px 16px',
  marginBottom: '15px',
  border: '1px solid rgba(255, 255, 255, 0.2)',
  borderRadius: '8px',
  fontSize: '1rem',
  color: '#fff',
  backgroundColor: 'rgba(255, 255, 255, 0.05)',
  outline: 'none',
  fontFamily: 'inherit'
};

const buttonStyle = {
  width: '100%',
  padding: '12px',
  backgroundColor: '#25D366',
  color: '#fff',
  fontSize: '1rem',
  fontWeight: 'bold',
  border: 'none',
  borderRadius: '30px',
  cursor: 'pointer',
  transition: 'all 0.3s ease',
  fontFamily: 'inherit',
};

export default ContactForm;
